import { CALL_API } from 'redux-api-middleware'
import {
  SEND_CONTACT_REQUEST,
  SEND_CONTACT_SUCCESS,
  SEND_CONTACT_FAILURE,
} from './types'

import { token } from '../utils'
const headers = {
  'x-session-token': token,
  'server-name': 'deknerd',
}

export const sendingContact = (endpoint, contactForm) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'POST',
        body: JSON.stringify(contactForm),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'x-session-token': token,
          'server-name': 'deknerd',
        },
        types: [
          SEND_CONTACT_REQUEST,
          {
            type: SEND_CONTACT_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              return response
            },
          },
          {
            type: SEND_CONTACT_FAILURE,
            payload: async (action, state, res) => {
              const response = await res.json()
              return response
            },
          },
        ],
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/contact.js